<template>
  <div v-cloak class="Resource">
    <!-- 头部banner图 -->
    <div class="swiper">
      <div class="toptexts">
        <div class="imgtitle">展映基地</div>
        <div class="texts">汇聚行业大咖，交流创作心得</div>
      </div>
    </div>

    <!-- 中间内容 -->
    <div class="containers">
      <div class="pa-t-30"><Bread :list="breadList" /></div>
      <div class="flex ma-t-30 bg-fff c-8a">
        <div class="c-000">分类：</div>
        <div class="flex">
          <div
            class="pointer"
            :class="0 == queryList.category1 ? 'curStyle' : ''"
            @click="typeSwitch(2,0)"
          >
            全部
          </div>
          <div
            v-for="(item, index) in kinds"
            :key="index"
            class="ma-l-50 pointer"
            :class="item.Id == queryList.category1 ? 'curStyle' : ''"
            @click="typeSwitch(2,item.Id)"
          >
            {{ item.Name }}
          </div>
        </div>
      </div>
      <div class="flex bg-fff pa-b-30 ma-t-30 c-8a">
        <div class="c-000">筛选：</div>
        <div class="flex">
          <div
            class="pointer"
            :class="0 == queryList.time ? 'curStyle' : ''"
            @click="typeSwitch(3,0)"
          >
            全部
          </div>
          <div
            v-for="(item, index) in qTs"
            :key="index"
            class="ma-l-50 pointer"
            :class="item.Id == queryList.time ? 'curStyle' : ''"
            @click="typeSwitch(3,item.Id)"
          >
            {{ item.Name }}
          </div>
        </div>
      </div>
        <div ref="cp">
          <!-- 课程中心 -->
          <div
            class="box flex"
            v-for="(item, index) in dataList.Data"
            :key="index"
          >
            <img :src="item.MainImage" class="img_230 img_cover" />
            <div class="ma-l-10 flex-grow-1">
              <span class="fon-18 weight500">{{ item.Name }}</span>
              <div class="ma-t-15 fon-14 c-5 t-omit-3 ">
                {{ item.Summary }}
              </div>
              <br>
              <div class="flex">
                <div class="ma-t-4 ma-b-4 width70">
                  <div>
                  <span class="ma-r-30 width40 d-i-b">时间：{{ item.StartTime }} </span>
                  <span class="ma-r-30">活动人数：{{ item.MaxCount }}人</span>
                  </div>
                <div class="ma-t-10">
                  <span class="ma-r-30 width40 d-i-b">活动方式：线下活动</span>
                  <span class="ma-r-30"
                    >联系方式：{{ item.Phone }}（{{ item.Linkman }}）</span
                  >
                  </div>
                </div>
                <div
                  class="btn_green flex f-center f-jcenter fon-12"
                  @click="plays(item.Id)"
                >
                  立即参加
                </div>
              </div>
            </div>
          </div>
          <div v-if="dataList.Data && dataList.Data.length == 0" class="width100">
              <div class="t-center ma-t-40">
                <img src="../img/empty.png" alt="" srcset="" width="200" />
                <div class="c-999">暂无数据</div>
              </div>
            </div>
        </div>

        <div class="fy">
          <el-pagination
            @current-change="handleCurrentChange"
            :hide-on-single-page="true"
            :current-page.sync="pageIndex"
            :page-size="pageSize"
            layout="prev, pager, next, jumper"
            :total="totals"
          ></el-pagination>
        </div>

      <el-dialog :visible.sync="play" width="40%" :show-close="false">
        <div class="pa-tb-40">
          <div class="t-center fon-18 font-bold">活动报名</div>

          <div class="width419 ma-center">
            <el-input
              placeholder="请输入姓名"
              class="ma-tb-30"
              v-model="name"
            ></el-input>
            <el-input placeholder="请输入联系方式" v-model="phone"></el-input>
          </div>

          <div>
            <div class="flex ma-t-70 f-around">
              <div class="btn_green flex f-center f-jcenter" @click="submit">
                提交
              </div>
              <div
                class="btn_white flex f-center f-jcenter"
                @click="play = false"
              >
                取消
              </div>
            </div>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.w-70{
  widows: 70%;
}
.curStyle {
  font-weight: 700;
  color: #fb004d;
}
#w-1200px{
  width: 1200px;
}
.rz {
  width: 50%;
  margin: 15px auto;
  border-radius: 3px;
  text-align: center;
  padding: 10px 10px;
  background-color: #e6e6e6;
  color: #000;
  font-weight: 500;
}
.containerss {
  width: 1200px;

  margin: 0 auto;
  background: #ffffff;
  padding: 0px 14px 25px 14px;
  box-sizing: border-box;

  .fy {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .product-main {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    .product-list {
      width: 370px;
      height: 121px;
      margin-right: 20px;
      margin-bottom: 38px;
      display: flex;
      justify-content: flex-start;
      .p-image {
        width: 35%;
        height: 121px;
        margin-right: 9px;
        .p-imgs {
          width: 121px;
          height: 121px;
          border-radius: 10px;
        }
      }
      .p-title {
        font-size: 20px;
        font-family: MicrosoftYaHei;
        color: rgba(102, 102, 102, 1);
        margin-bottom: 8px;
      }
      .p-detail {
        // width:100%;
        font-size: 14px;
        height: 38px;
        line-height: 19px;
        font-family: MicrosoftYaHei;
        color: rgba(102, 102, 102, 1);
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
      }
      .p-right {
        width: 65%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
      }
      .download {
        width: 90px;
        height: 30px;
        background: rgba(15, 117, 189, 1);
        border-radius: 20px;
        font-size: 14px;
        font-family: MicrosoftYaHei;
        color: rgba(255, 255, 255, 1);
        text-align: center;
        line-height: 30px;
        cursor: pointer;
        text-decoration: none;
      }
    }
  }
}
.Resource {
  min-width: 1200px;
  background: rgba(245, 247, 250, 1);
}
.Resource .swiper {
  width: 100%;
  height: 314px;
  background-image: url(../img/活动.png);
   background-size:cover;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;
  .toptexts {
    width: 736px;
    position: absolute;
    top: 28%;
    margin: 0 auto;
    left: 50%;
    margin-left: -368px;
    font-size: 20px;
    font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;

    color: #fff;
    opacity: 0.75;
    text-align: center;
    .texts {
      line-height: 30px;
      letter-spacing: 3px;
      font-size: 16px;
    }
    .imgtitle {
      font-size: 24px;
      font-weight: bold;
      margin-bottom: 20px;
    }
  }
}
.fy {
  margin-top: 55px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.Resource .container {
  width: 100%;
  // height: 600px;
  min-height: 1150px;
  background: #ffffff;
  box-sizing: border-box;
  padding: 0 40px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
}
.Resource .container {
  .el-tabs__header {
    display: flex;
    justify-content: center;
  }
  .el-tabs__content {
    min-width: 1080px;
    margin: 0 auto;
  }
  .el-tabs__item {
    padding: 0 60px;
    font-size: 14px;
    font-family: MicrosoftYaHei;
    color: #333333;
  }
  .el-tabs__active-bar {
    height: 4px;
    font-weight: bold;
    background: #fb004d;
  }
  .is-active {
    font-size: 14px;
    font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
    font-weight: bold;
    color: #fb004d;
  }
  .el-tabs__content {
    margin-top: 45px;
  }
}
.Resource .student {
  width: 1100px;
  height: 106px;
  margin-bottom: 32px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;

  .img-left {
    width: 20%;
    height: 106px;

    .img-lefts {
      width: 187px;
      height: 106px;
    }
  }
  .text-right {
    width: 80%;
    .title {
      font-size: 14px;
      font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
      font-weight: bold;
      color: #333333;
      margin-top: 3px;
      margin-bottom: 5px;
    }
    .text-detail {
      padding-right: 100px;
      box-sizing: border-box;
      font-size: 12px;
      line-height: 18px;
      font-family: MicrosoftYaHei;
      color: rgba(102, 102, 102, 1);
      text-overflow: -o-ellipsis-lastline;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      line-clamp: 3;
      -webkit-box-orient: vertical;
    }
    .icons {
      // width: 100%;
      margin-top: 8px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .deletes {
        font-size: 12px;
        font-family: MicrosoftYaHei;
        color: rgba(102, 102, 102, 1);
        display: flex;
        justify-content: space-between;
        align-items: center;
        .icons-right-children {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          i {
            font-size: 18px;
          }
        }
      }

      .icons-left {
        width: 100%;
        padding-right: 100px;
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .icons-left-children {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          div {
            font-size: 12px;
            font-family: MicrosoftYaHei;
            color: rgba(102, 102, 102, 1);
            margin-left: 8px;
          }
        }
      }
      .delete-right {
        width: 40%;
        .icons-right-children {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          div {
            font-size: 12px;
            font-family: MicrosoftYaHei;
            color: rgba(102, 102, 102, 1);
            margin-left: 8px;
          }
        }
      }
    }
  }
}
.ma-t-70 {
  margin-top: 70px;
}
.box {
  // width: 1200px;
  height: 175px;
  margin-top: 20px;
  border-bottom: #eee 1px solid;
}
.ma-t-60 {
  margin-top: 60px !important;
}
.ma-t-10 {
  margin-top: 10px !important;
}
.btn_green {
  width: 220px;
  height: 40px;
  background: #fb004d;
  border-radius: 20px;
  color: #fff;
}
.btn_white {
  width: 220px;
  height: 40px;
  background: #ffffff;
  border: 1px solid #fb004d;
  border-radius: 20px;
  color: #fb004d;
}
.img_230 {
  width: 230px;
  height: 149px;
}
.c-5 {
  color: #555555;
}
.height300 {
  height: 80px;
}
.width419 {
  width: 419px;
}
.containers{
    width: 1200px;
    margin: 0 auto 30px auto;
    padding: 0px 14px 25px 24px;
    box-sizing: border-box;
    background: #fff;
}
.ma-b-4{
  margin-bottom: 4px;
}
.ma-t-4{
  margin-top: 4px;
}
.w-50{
  width: 50%;
} 
.w-100{
  width: 100%;
}
.d-i-b{
  display: inline-block;
}
</style>
<script>
import { Activitys, sign,PracticeKinds } from "../api.js";
import Bread from "../components/Bread.vue";

// studycollect
export default {
  name: "Practice",
  components: {
    Bread,
  },
  data() {
    return {
      queryList:{
        time:'0',//查询条件  1 表示今天 7 表示 本周 30 表示本月
        category2:0,
        category1:0
      },
      qTs:[
        {Name:'今天',Id:'1'},
        {Name:'本周',Id:'7'},
        {Name:'本月',Id:'30'},
        {Name:'往期活动',Id:'-1'},
      ],
      kinds: [
      ],
      kinds2:[],//二级分类
      kindcontainer: [],
      kindlength: "",
      pageIndex: 1, //当前页数
      pageSize: 10,
      totals: 0, //一个分类下的总条数
      play: false,
      dataList: {},
      name: "",
      id: 0,
      phone: "",
      isdone: true,
      breadList: [{ name: "展映基地", path: "/Practice" }],
    };
  },

  created() {
    // console.log("created----");
    this.getList();
    this.getKinds()
  },
  beforeRouteEnter(to, from, next) {
    window.scroll(0, 0);

    next();
  },

  // 其他页面进来时更新初始数据
  activated() {},

  methods: {
    //切换分类和切换筛选条件
    typeSwitch(f,id){
      switch (f) {
        case 2:
          this.queryList.category1=id
          break;
        case 3:
          this.queryList.time=id
          break;
        default:
          break;
      }
      this.getList()
    },
    //获取分类
    getKinds(){
      PracticeKinds().then(res=>{
        this.kinds=res.data.Data;
      })
    },
    getList() {
      let data = {
        pageindex: this.pageIndex,
        pagesize: this.pageSize,
        category1:this.queryList.category1,
        category2:this.queryList.category2,
        time:this.queryList.time
      };
      Activitys(data).then((res) => {
        if (res.data.Code == 0) {
          // console.log(res);
          this.dataList = res.data.Data;
          this.totals = res.data.Data.TotalCount;
        }
      });
    },
    plays(e) {
      this.$router.push({
        path: "/Activity",
        query: {
          id: e,
        },
      });

      // this.play = true;
      // this.id = e;
      // let token = localStorage.getItem("AccessToken");
      // let data = { token: token };
      // getuser(data).then((res) => {
      //   if (res.data.Code == 0) {
      //     this.name = res.data.Data.Name;
      //     this.phone = res.data.Data.Phone;
      // }
      // });
      // console.log(e);
    },
    toDetail(id = 1) {
      this.$router.push({
        path: "/Learn-detail",
        query: { id: id },
      });
    },

    //点击切换种类
    handleClick(tab) {
      this.kinds2=this.kinds[tab.index].Chirden
      this.queryList.category1=tab.name
      this.queryList.time=0;
      this.queryList.category2=0;
      this.pageIndex = 1;
      this.getList();
    },

    upload(e) {
      window.open(e, "_blank");
    },

    // 详情
    collect(id) {
      this.$router.push({
        path: "/Study-detail",
        query: { paths: "/Resource", name: "学习资源", id: id },
      });
    },

    // 当前页改变时触发
    handleCurrentChange(e) {
      // console.log(e);
      this.pageIndex = e;
      this.getList();
    },

    //报名提交
    submit() {
      var that = this;
      var reg = 11 && /^((13|14|15|17|18|16|19|11|12)[0-9]{1}\d{8})$/;

      if (this.name == "") {
        this.$message.error("姓名不能为空哦！");
        return;
      }
      if (this.phone.length < 1) {
        this.$message.error("手机号不能为空哦！");
        return;
      } else if (!reg.test(this.phone)) {
        this.$message.error("手机格式不正确！");
        return;
      }

      let token = localStorage.getItem("AccessToken");
      let data = {
        Token: token,
        Name: this.name,
        Phone: this.phone,
        Id: this.id,
      };
      sign(data).then((res) => {
        // console.log(res);
        if (res.data.Code == 0) {
          that.$message.success("报名成功");
          that.play = false;
        } else {
          that.$message({
            message: res.data.Message,
            type: "warning",
            center: true,
            customClass: "sps",
          });
        }
      });
    },
  },
};
</script>
